var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEye32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.2a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm-3.25 1.75a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.063 16a20.265 20.265 0 002.524 2.603c1.759 1.507 4.064 2.897 6.528 2.897 2.465 0 4.77-1.39 6.528-2.897A20.272 20.272 0 0025.168 16a20.272 20.272 0 00-2.525-2.603C20.885 11.89 18.58 10.5 16.115 10.5c-2.464 0-4.769 1.39-6.528 2.897A20.265 20.265 0 007.063 16zm1.548-3.742C10.463 10.672 13.113 9 16.115 9c3.003 0 5.653 1.672 7.504 3.258a21.118 21.118 0 013.09 3.283.748.748 0 010 .918c-.148.202-1.3 1.749-3.09 3.283C21.768 21.328 19.12 23 16.115 23c-3.002 0-5.652-1.672-7.504-3.258a21.118 21.118 0 01-3.09-3.283.748.748 0 010-.918c.148-.202 1.3-1.749 3.09-3.283z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye32);
export default __webpack_public_path__ + "static/media/icon-eye-32.a4a8e168.svg";
export { ForwardRef as ReactComponent };